import React from "react";
import {Navigate} from 'react-router-dom'
import {isLogin} from "../utils/general-variable";

export const PrivateRoute = ({ children }) => {
    const isAuthenticated = isLogin()

    return !!isAuthenticated ? children : <Navigate to="/" />
}
